import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import * as M from "../../../../models";
import _ from "lodash";

interface OwnProps {
    classifications: M.Search.SearchFilter[];
    gradingGroups: M.Search.SearchFilter[];
    invitationResponses: M.Search.SearchFilter[];
    loadingEvent: boolean;
    placements: M.Search.SearchFilter[];
    statuses: M.Search.SearchFilter[];
    types: M.Search.SearchFilter[];
    onFilterSelect: (id: string | number, checked: boolean, type: FilterType) => void;
}

interface OwnState {
}

export type FilterType = "noAuthors" | "class" | "group" | "invitation" | "place" | "status" | "type";

export class Filters extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {

        const loading = this.props.loadingEvent
            ? <Comp.Generic.WrapperLess>
                <Comp.Generic.LoadingIcon /> Loading&hellip;
            </Comp.Generic.WrapperLess>
            : null;

        const checkedStatus = this.props.statuses.filter((x) => x.checked).length
            ? this.props.statuses.filter((x) => x.checked)[0].name
            : "All";

        const filters = this.props.loadingEvent
            ? null
            : <Comp.Generic.WrapperLess>
                <h3>Status</h3>

                <BS.DropdownButton id="filters-status" title={checkedStatus}>
                    <BS.MenuItem key={0} onClick={() => this.props.onFilterSelect(0, false, "status")}>
                        All
                    </BS.MenuItem>
                    {_.orderBy(this.props.statuses, (x) => x.name).map((s, i) => (
                        <BS.MenuItem key={i} onClick={() => this.props.onFilterSelect(s.id, true, "status")}>
                            {s.name}
                            {s.count ? <span className="mute"> ({s.count})</span> : null}
                        </BS.MenuItem>
                    ))}
                </BS.DropdownButton>

                <hr />

                <Comp.Search.SearchFilterCategory
                    defaultSort="name"
                    excludeZeros
                    filters={this.props.types}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "type")}
                    showAll
                    title="Format"
                />

                <Comp.Search.SearchFilterCategory
                    defaultSort="name"
                    excludeZeros
                    filters={this.props.placements}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "place")}
                    title="Placement"
                />

                <Comp.Search.SearchFilterCategory
                    defaultSort="name"
                    excludeZeros
                    filters={this.props.classifications}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "class")}
                    title="Classification"
                />

                <Comp.Search.SearchFilterCategory
                    defaultSort="name"
                    excludeZeros
                    filters={this.props.gradingGroups}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "group")}
                    showAll
                    title="Grading group"
                />

                <Comp.Search.SearchFilterCategory
                    defaultSort="name"
                    filters={this.props.invitationResponses}
                    onChange={(id, checked) => this.props.onFilterSelect(id, checked, "invitation")}
                    showAll
                    title="Invitation"
                />
            </Comp.Generic.WrapperLess>;

        return <div className="results-filters">
            {/* <div className="search">
                <input
                    className="search-txt"
                    onChange={(e) => this.setState({ ...this.state, search: e.target.value })}
                    placeholder="Find..."
                    type="text"
                    value={this.state.search}
                />
                <button aria-label="Go" className="search-button">
                    <Comp.Generic.Icon icon="search" />
                </button>
            </div> */}

            {loading}

            {filters}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/list/components/Filters.tsx